import { Injectable } from '@angular/core';
import { NavToolbarButton } from './nav-toolbar.component';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class NavToolbarService {

  buttons: BehaviorSubject<NavToolbarButton[]> = new BehaviorSubject<NavToolbarButton[]>([]);
  constructor() { }

  setButtons(buttons: NavToolbarButton[]) {
    this.buttons.next(buttons);
  }

}
